import { Button, Empty, Skeleton } from 'antd';
import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';

/** Uniform loading skeleton for page bodies. */
export function LoadingBlock(): JSX.Element {
  return (
    <div style={{ padding: '8px 0' }}>
      <Skeleton active paragraph={{ rows: 3 }} />
      <Skeleton active paragraph={{ rows: 3 }} />
    </div>
  );
}

/** Uniform query-error state with a retry button. */
export function ErrorBlock({ onRetry }: { onRetry: () => void }): JSX.Element {
  const { t } = useTranslation();
  return (
    <Empty description={t('common.loadError')} style={{ marginTop: 48 }}>
      <Button onClick={onRetry}>{t('common.retry')}</Button>
    </Empty>
  );
}

/** Friendly empty state. */
export function EmptyBlock({
  description,
  hint,
}: {
  description: string;
  hint?: string;
}): JSX.Element {
  return (
    <Empty
      style={{ marginTop: 48 }}
      description={
        <>
          <div>{description}</div>
          {hint ? <div style={{ color: '#999', fontSize: 13, marginTop: 4 }}>{hint}</div> : null}
        </>
      }
    />
  );
}
